var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"changelog"},domProps:{"innerHTML":_vm._s(_vm.changelog)}})
}
var staticRenderFns = []

export { render, staticRenderFns }